import { LanguageTemplateEnum } from '@page/explorer/templates';

export const codeExampleOptions = [
  {
    value: LanguageTemplateEnum.CURL,
    label: 'cURL',
  },
  {
    value: LanguageTemplateEnum.AXIOS,
    label: 'Axios - NodeJS',
  },
  {
    value: LanguageTemplateEnum.JS,
    label: 'Request - NodeJS',
  },
  {
    value: LanguageTemplateEnum.PHP,
    label: 'PHP',
  },
  {
    value: LanguageTemplateEnum.PYTHON,
    label: 'Python',
  },
  {
    value: LanguageTemplateEnum.RUBY,
    label: 'Ruby',
  },
  {
    value: LanguageTemplateEnum.GO,
    label: 'GO',
  },
];
